import PasswordCheckModal from "./password-check-modal.vue";

export default PasswordCheckModal;



// WEBPACK FOOTER //
// ./src/components/_modals/password-check/index.js